import { showNotification } from 'SourceStore/Notification/Notification.action';
import { QueryDispatcher } from 'SourceUtil/Request';
import { event } from './GoogleTagManager.action';
import { EVENT_GTM_PURCHASE } from '../../component/GoogleTagManager/GoogleTagManager.events';
import GoogleTagManagerQuery from '../../query/GoogleTagManager.query';
import { updateConfig } from './GoogleTagManager.action';
import {
    fetchQuery
} from 'SourceUtil/Request';
import GtmPurchaseQuery from '../../query/GtmPurchase.query';

/** @namespace GtmNew/Store/GoogleTagManager/Dispatcher/GoogleTagManagerDispatcher */
export class GoogleTagManagerDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct();
    }

    onSuccess({ gtm }, dispatch, options) {
        if (gtm) {
            dispatch(updateConfig({ gtm }));
        }
    }

    onError(error, dispatch, options) {
        dispatch(showNotification('error', 'Error fetching GoogleTagManager!', error));
    }

    getPurchase = (options, dispatch) => {
        const { totals, orderID } = options;
        
        const query = GtmPurchaseQuery.getGTMPurchase(orderID);
        // dispatch(event(EVENT_GTM_PURCHASE, options));
        fetchQuery(query).then(({ purchase }) => {
            dispatch(event(EVENT_GTM_PURCHASE, { ...purchase, orderID }));
        });
    };

    prepareRequest(orderID, dispatch) {
        if(dispatch && orderID) {
            return this.getPurchase(orderID, dispatch);
        }

        return GoogleTagManagerQuery.getGTMConfiguration();
    }
}

export default new GoogleTagManagerDispatcher();
